'use strict';

const Backbone = require('backbone');

class BaseModel extends Backbone.Model {
  constructor() {
    super(...arguments);
    if (typeof this.error === 'function') {
      this.on('error', this.error, this);
    }
  }
}

module.exports = BaseModel;
